import {
  type BlockCore,
  type BuilderState,
  type ResourceCore,
} from '../../types'

export const currentResource = <
  TResource extends ResourceCore,
  TBlock extends BlockCore,
>(
  state: BuilderState<TResource, TBlock>
): TResource | undefined => {
  return state._builder_currentState.resource
}
